// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { baseUrl } from './../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getSubTopicList = createAsyncThunk(
  'subTopic/getSubTopicList',
  async (params) => {
    const response = await axios.get(baseUrl() + '/sub-topic', { params })
    // dispatch(setLoader(false))
    return {
      totalPages: response.data.count,
      subTopicList: response.data.data,
      loader: false
    }
  }
)

export const addSubTopic = createAsyncThunk(
  'subTopic/addSubTopic',
  async ({ formData, pageNo, pageSize, search }, { dispatch }) => {
    try {
      const res = await axios.post(baseUrl() + '/sub-topic', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      toast.success(res?.data?.message)
      await dispatch(
        getSubTopicList({
          pageNo,
          pageSize,
          search
        })
      )
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    } finally {
      dispatch(setLoading(false))
    }
  }
)

export const updateSubTopic = createAsyncThunk(
  'subTopic/updateSubTopic',
  async ({ id, updateData, pageNo, pageSize, search }, { dispatch }) => {
    try {
      const res = await axios.put(baseUrl() + `/sub-topic/${id}`, updateData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      toast.success(res?.data?.message)
      await dispatch(
        getSubTopicList({
          pageNo,
          pageSize,
          search
        })
      )
      return { id }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    } finally {
      dispatch(setLoading(false))
    }
  }
)

export const deleteSubTopic = createAsyncThunk(
  'subTopic/deleteSubTopic',
  async ({ id, pageNo, pageSize, search }, { dispatch }) => {
    try {
      // dispatch(setLoader(false))
      const res = await axios.delete(baseUrl() + '/sub-topic/' + id)
      toast.success(res?.data?.message)
      await dispatch(
        getSubTopicList({
          pageNo,
          pageSize,
          search
        })
      )
      return id
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
)

export const SubTopicSlice = createSlice({
  name: 'subTopic',
  initialState: {
    subTopicList: [],
    selected: null,
    getFiles: [],
    loader: false,
    loading: false,
    totalPages: 0
  },
  reducers: {
    selectSubTopic: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubTopicList.fulfilled, (state, action) => {
        ;(state.subTopicList = action.payload.subTopicList),
          (state.totalPages = action.payload.totalPages)
        state.loader = false
      })
      .addCase(getSubTopicList.pending, (state) => {
        state.loader = true
      })
  }
})

export const { selectSubTopic, setLoader, setLoading } = SubTopicSlice.actions

export default SubTopicSlice.reducer
